import { loadWithRetry } from '@frontend/duck-tape';

const POLL_INTERVAL_MS = 50;
const DEFAULT_TIMEOUT_MS = 5_000;
const GOOGLE_IDENTITY_SERVICES_LOAD_ERROR_MESSAGE = 'Google Identity Services script did not load in time';

const isGoogleIdentityServicesReady = (): boolean => Boolean(window.google?.accounts?.oauth2);

const getTotalAttempts = (timeoutMs: number): number => Math.ceil(timeoutMs / POLL_INTERVAL_MS) + 1;

// GIS script in index.html loads async+defer, so it may not be ready on first click.
export const waitForGoogleIdentityServices = (timeoutMs: number = DEFAULT_TIMEOUT_MS): Promise<void> =>
  loadWithRetry({
    load: async () => {
      if (isGoogleIdentityServicesReady()) return;
      throw new Error(GOOGLE_IDENTITY_SERVICES_LOAD_ERROR_MESSAGE);
    },
    retryDelayMs: POLL_INTERVAL_MS,
    timeoutMs: POLL_INTERVAL_MS,
    totalAttempts: getTotalAttempts(timeoutMs),
  });
